<template>
<div class="chapter">
<div class="inner_page">
<p class="para"> </p>
<p class="para"> </p>
<p class="copy">First published in Great Britain in 2022 by Polygon,</p>
<p class="copy">an imprint of Birlinn Ltd</p>
<p class="copy1">Birlinn Ltd</p>
<p class="copy">West Newington House</p>
<p class="copy">10 Newington Road</p>
<p class="copy">Edinburgh</p>
<p class="copy">EH9 1QS</p>
<p class="copy1"><a href="http://www.polygonbooks.co.uk" target="_blank">www.polygonbooks.co.uk</a></p>
<p class="copy1">1</p>
<p class="copy1">Copyright © Alastair McKay, 2022</p>
<p class="copy1">The right of Alastair McKay to be identified as the author of this work has been asserted in accordance with the Copyright, Designs and Patents Act 1988.</p>
<p class="copy1">All rights reserved.</p>
<p class="copy1">ISBN 978 1 84697 581 3</p>
<p class="copy">eBook ISBN 978 1 78885 494 8</p>
<p class="copy1">Typeset by 3B Type, Edinburgh</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?14a8e93c